import { Form, Radio, Button } from 'antd';

import styles from './index.module.scss';

interface QuestionnaireProps {
  id?: string;
}

export default function Questionnaire({ id }: QuestionnaireProps) {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    // TODO complete functionality
    console.log(id, 'Received values:', values);
  };

  return (
    <div className={styles.card}>
      <h2 style={{ marginBottom: '20px' }}>Questionnaire</h2>

      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item
          name="question1"
          label={(
            <h3>
              How useful did you find the information or instruction on this
              page?
            </h3>
          )}
          rules={[{ required: true, message: 'Please select an option' }]}
        >
          <Radio.Group className={styles.radio}>
            <Radio value="very">Very useful</Radio>
            <Radio value="somewhat">Somewhat useful</Radio>
            <Radio value="not">Not that useful</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="question2"
          label={(
            <h3>
              How useful did you find the information or instruction on this
              page?
            </h3>
          )}
          rules={[{ required: true, message: 'Please select an option' }]}
        >
          <Radio.Group className={styles.radio}>
            <Radio value="very">Very useful</Radio>
            <Radio value="somewhat">Somewhat useful</Radio>
            <Radio value="not">Not that useful</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button type="primary" htmlType="submit" size="large">
              Submit
            </Button>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
}
